var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"global-loader"},[_c('div',{staticClass:"loader-icon"}),_c('p',[_vm._v("Loading data, please wait...")])]):_c('div',[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }